// Flattens the JSON:API CommentSerializer payload (whose replies live under a
// nested `children.data`) into the plain tree the modal renders. Defensive by
// design: a partial or absent payload during the BE rollout degrades to an empty
// list instead of throwing.
export const normalizeComment = (node) => {
  if (!node) {
    return null
  }

  const { id, attributes = {} } = node
  const { content, createdAt, author = {}, children } = attributes
  const replies = (children?.data || [])
    .map(normalizeComment)
    .filter(Boolean)

  return {
    id: Number(id),
    content: content || '',
    createdAt: createdAt || null,
    author: {
      id: author.id ?? null,
      // Generator::Run comments serialize a `displayName` (username_or_full_name);
      // fall back to the raw username for other commentable types / optimistic nodes.
      username: author.displayName || author.username || '',
      avatarUrl: author.avatarUrl || null,
      isAuthor: !!author.isAuthor,
    },
    replies,
  }
}

// Accepts the list payload ({ data: [...] }) returned by the run comments index.
export const normalizeCommentsList = (payload) => {
  const list = payload?.data

  if (!Array.isArray(list)) {
    return []
  }

  return list.map(normalizeComment).filter(Boolean)
}
